import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query CalendarModalities($page: Int, $perPage: Int, $search: String) {
    CalendarModalities(page: $page, perPage: $perPage, search: $search) {
      items {
        id
        title
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface GetAllItem {
  id: number;
  title: string;
}

export interface GetAllGql {
  CalendarModalities: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
